import { generateID } from '@builder/utils';
import { COMPONENT_SETTING_TYPES } from '../../../constants';
export const getDivider = ({ name, devMode, showIf, } = {}) => ({
    type: COMPONENT_SETTING_TYPES.divider,
    name: name || generateID(4),
    devMode,
    showIf,
});
